<a style="cursor: pointer;" *ngIf="isShow" (click)="gotoTop()">Scroll To</a>